import { render, staticRenderFns } from "./shipmentAgreement.vue?vue&type=template&id=725c5b90&scoped=true"
import script from "./shipmentAgreement.vue?vue&type=script&lang=js"
export * from "./shipmentAgreement.vue?vue&type=script&lang=js"
import style0 from "./shipmentAgreement.vue?vue&type=style&index=0&id=725c5b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c5b90",
  null
  
)

export default component.exports